import React from "react";

const PartnershipImage = ({ img }) => {
  return <img className="h-[190px] flex justify-center mx-auto" src={img} alt="" />;
};

export default PartnershipImage;
